import { Check } from 'lucide-react';

export function Checkbox({ checked, onChange, label, disabled }: { checked: boolean; onChange: (checked: boolean) => void; label?: string; disabled?: boolean }) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`inline-flex items-center gap-2 text-left disabled:opacity-50 ${label ? '' : ''}`}
    >
      <span className={`grid size-5 shrink-0 place-items-center rounded-md border transition-colors ${checked ? 'border-brand-600 bg-brand-600' : 'border-border bg-white'}`}>
        {checked && <Check size={14} strokeWidth={3} className="text-white" />}
      </span>
      {label && <span className="text-sm">{label}</span>}
    </button>
  );
}
